module.exports = __webpack_public_path__ + "static/media/logo.9a844a9c.svg";